import api from '@/api';
export default {
  name: "LeftMenu",
  data() {
    return {
      permission: this.$store.state.user.permission,
      role: this.$store.state.user.role
    };
  },
  methods: {
    async logout() {
      await api.addLoginRecord({
        userId: this.$store.state.user.id,
        userName: this.$store.state.user.name,
        createTime: Date.now(),
        type: 1
      });
      this.$store.commit("logout");
    }
  }
};